<template>

    <section id="new_ref_fifth_step" class="flex">

        <titlePage>
            <template slot="titleBody">
                <h1 class="title is-size-1 has-text-weight-light stepTitle page-title">{{ currentPosition.name }}</h1>
                <h2 class="associated_ref_name">{{ $t('modules.positions.formStep3.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
            </template>
        </titlePage>

        <div class="container ">

            <AddContacts @contactListModified="handleContactList" ref="addContactComponent2" contactLabel="candidat" :allowFileUpload="true">
                <template slot="headSlot">
                    <h2 class="title is-size-1 has-text-weight-bold stepTitle has-text-right">{{ $t('modules.positions.formStep3.title') }}</h2>
                    <notifText class="text_notice_add_candidates">
                        {{ $t('modules.positions.formStep3.notice') }}
                    </notifText>
                </template>
            </AddContacts>

            <div class="next_step_button has-text-centered">
                <btn-circle-icon
                    class="large is-cursor"
                    icon="icon-arrow-right"
                    @click.native="nextStep" />
            </div>

        </div>

    </section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import AddContacts from '@/components/shared/addContacts/addContacts'

export default {
    name: 'formEvalStep3',
    components: {
        titlePage,
        AddContacts
    },
    data(){
        return {
            contactList: []
        }
    },
    mounted(){
        this.$store.commit('PositionStore/updateFormValidity', { index: 2, validity: true } )
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        associatedRef(){
            return this.$store.state.PositionStore.associatedRef
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        handleContactList(contactList){
            this.contactList = contactList
            const evalItemsList = []
            contactList.forEach((evaluation) => {
                evalItemsList.push({ 
                    candidate_first_name: evaluation.first_name, 
                    candidate_last_name: evaluation.last_name, 
                    candidate_email: evaluation.email,
                    docs_ids: evaluation.docs_ids
                })
            })
            this.$store.commit('PositionStore/setEvalList', evalItemsList)
        },
        nextStep(){
            this.$store.commit('PositionStore/changeCurrentStep', { index: 3 })
        },
    }
}

</script>

<style lang="scss" >
#new_ref_fifth_step{
    background: $white;
}

.next_step_button{
    margin-top: 50px;
}
.text_notice_add_candidates{
    text-align: right;
    max-width: 450px;
    margin-left:auto;
}
</style>